"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6423],{

/***/ 49574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ StarNumRating; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./main/javascripts/styles/fontStyle.ts + 3 modules
var fontStyle = __webpack_require__(6900);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/StarRating/StarRating.tsx


var _excluded = ["rating"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var getStarStyle = function getStarStyle(rating) {
  var starVal = Math.round(rating * 2) / 2;
  var starString = "star".concat(starVal.toString().replace(".", "_"));
  return fontStyle/* starIconStyle */.SF[starString];
};

var StarRating = function StarRating(props) {
  var rating = props.rating,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  if (rating === 0) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", _objectSpread(_objectSpread({
    css: blockStyle
  }, rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: iconBlockStyle,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: [starRatingStyle, fontStyle/* starIconStyle.starEmpty */.SF.starEmpty,  true ? "" : 0,  true ? "" : 0]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: [starRatingStyle, starPositiveStyle, getStarStyle(rating),  true ? "" : 0,  true ? "" : 0]
      })]
    })
  }));
};
var starRatingStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("color:", colorStyle/* accentColor.starColor */.z.starColor, ";overflow:hidden;margin:0;line-height:1;" + ( true ? "" : 0),  true ? "" : 0);
var starPositiveStyle =  true ? {
  name: "14fvduy",
  styles: "position:absolute;top:0;left:0"
} : 0;
var iconBlockStyle =  true ? {
  name: "2ci6dh",
  styles: "position:relative;display:inline-block;vertical-align:middle"
} : 0;
var blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:relative;font-size:", typographyStyle/* fontSize.body */.JB.body, ";line-height:0.1;" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
;// CONCATENATED MODULE: ./main/javascripts/components/StarRating/StarNumRating.tsx


var StarNumRating_excluded = ["rating"];

function StarNumRating_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function StarNumRating_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? StarNumRating_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : StarNumRating_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var StarNumRating = function StarNumRating(props) {
  var rating = props.rating,
      rest = (0,objectWithoutProperties/* default */.Z)(props, StarNumRating_excluded);

  if (rating === 0) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", StarNumRating_objectSpread(StarNumRating_objectSpread({
    css: StarNumRating_blockStyle
  }, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StarRating, {
      rating: rating
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: numStyle,
      children: rating
    })]
  }));
};
var StarNumRating_blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:relative;font-size:", typographyStyle/* fontSize.body */.JB.body, ";display:flex;align-items:center;" + ( true ? "" : 0),  true ? "" : 0);
var numStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";line-height:", typographyStyle/* lineHeight.noSpace */.Nv.noSpace, ";color:", colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor, ";display:inline-block;vertical-align:middle;padding:0 0 0 ", spaceStyle/* space.atom0_5x */.D.atom0_5x, ";letter-spacing:0.05em;" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 34216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CardColumn; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);


var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




var CardColumn = function CardColumn(props) {
  var children = props.children,
      rest = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, _excluded);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", _objectSpread(_objectSpread({
    css: cardColumnStyle
  }, rest), {}, {
    children: children
  }));
};
var cardColumnStyle =  true ? {
  name: "lkh5er",
  styles: "display:flex;flex-wrap:wrap;align-items:center"
} : 0;

/***/ }),

/***/ 83981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ HotelDestinationBlock; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(70917);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26793);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(87536);
/* harmony import */ var main_javascripts_components_form_InputAutosuggestBlock__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1399);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79169);
/* harmony import */ var main_javascripts_features_hotel_hotelSuggestionSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86058);
/* harmony import */ var _form_InputHidden__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81047);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14416);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88433);
/* harmony import */ var _suggestionPicker_SuggestionPicker__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50193);
/* harmony import */ var _molecules_Modal_FullScreenModalDialog__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19484);
/* harmony import */ var _suggestionPicker_SuggestionFieldButton__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(83827);
/* harmony import */ var _styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36716);
/* harmony import */ var _constants_FormConstants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(36581);
/* harmony import */ var _utils_googleTagManagerUtil__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(49224);
/* harmony import */ var _constants_GoogleTagManagerEventTypes__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(12327);
/* harmony import */ var _slices_accountParamSlice__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(12297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(35944);























var HotelDestinationBlock = function HotelDestinationBlock(props) {
  var fetchHotelDestinationSuggestions = props.fetchHotelDestinationSuggestions,
      defaultDestinations = props.defaultDestinations,
      suggestOptions = props.suggestOptions,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      disableStopBodyScrolling = props.disableStopBodyScrolling;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_16__/* .useTranslation */ .$)(["label"]),
      t = _useTranslation.t;

  var appDispatch = (0,main_javascripts_store__WEBPACK_IMPORTED_MODULE_3__/* .useAppDispatch */ .TL)();
  var accountDefaultDestinations = (0,main_javascripts_store__WEBPACK_IMPORTED_MODULE_3__/* .useAppSelector */ .CG)(_slices_accountParamSlice__WEBPACK_IMPORTED_MODULE_15__/* .defaultDestinationsSelector */ .fg);
  var destinations = (0,main_javascripts_store__WEBPACK_IMPORTED_MODULE_3__/* .useAppSelector */ .CG)(main_javascripts_features_hotel_hotelSuggestionSlice__WEBPACK_IMPORTED_MODULE_4__/* .hotelDestinationSuggestionsSelector */ .s0);
  var isLoading = (0,main_javascripts_store__WEBPACK_IMPORTED_MODULE_3__/* .useAppSelector */ .CG)(main_javascripts_features_hotel_hotelSuggestionSlice__WEBPACK_IMPORTED_MODULE_4__/* .loadingSelector */ .E2);
  var currentInputData = (0,main_javascripts_store__WEBPACK_IMPORTED_MODULE_3__/* .useAppSelector */ .CG)(main_javascripts_features_hotel_hotelSuggestionSlice__WEBPACK_IMPORTED_MODULE_4__/* .hotelDestinationInputDataSelector */ .TW);
  var currentInputText = currentInputData === null || currentInputData === void 0 ? void 0 : currentInputData.text;
  var currentInputLongName = currentInputData === null || currentInputData === void 0 ? void 0 : currentInputData.longName; // TODO: 旧reducerをそのまま使用

  var breakpoint = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function (state) {
    return state.breakpointReducer.breakpoint;
  });

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_17__/* .useFormContext */ .Gc)(),
      setValue = _useFormContext.setValue,
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors,
      trigger = _useFormContext.trigger;

  var fieldName = "destination";
  var idFieldName = "destination_id";
  var typeFieldName = "destination_type";
  var longitudeFieldName = "longitude";
  var latitudeFieldName = "latitude";
  var value = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_17__/* .useWatch */ .qo)({
    control: control,
    name: fieldName
  }) || "";

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      displayedPicker = _useState[0],
      setDisplayedPicker = _useState[1];

  var inputTimeoutRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var valueRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(value);
  valueRef.current = value;
  var currentInputLongNameRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(currentInputLongName);
  currentInputLongNameRef.current = currentInputLongName;
  var currentValue = (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_7__/* .isPhone */ .Mn)(breakpoint) ? value : value;

  var validDefaultDestinations = function validDefaultDestinations() {
    var _values$find;

    for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
      values[_key] = arguments[_key];
    }

    return (_values$find = values.find(function (value) {
      return value !== undefined && value.length > 0;
    })) !== null && _values$find !== void 0 ? _values$find : [];
  };

  var suggestions = currentValue ? destinations : validDefaultDestinations(defaultDestinations, accountDefaultDestinations);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    return function () {
      clearTimeout(inputTimeoutRef.current);
    };
  }, []);

  var hidePicker = function hidePicker() {
    setDisplayedPicker(false);
  };

  var onPickerButtonClick = function onPickerButtonClick() {
    setDisplayedPicker(true);
  };

  var onSelected = function onSelected(suggestion) {
    clearTimeout(inputTimeoutRef.current);
    var inputText = currentValue;
    setValue(fieldName, suggestion.longName);
    setValue(idFieldName, suggestion.id);
    setValue(typeFieldName, suggestion.destinationType);
    setValue(longitudeFieldName, suggestion.centerCoordinates[0]);
    setValue(latitudeFieldName, suggestion.centerCoordinates[1]);
    appDispatch((0,main_javascripts_features_hotel_hotelSuggestionSlice__WEBPACK_IMPORTED_MODULE_4__/* .setHotelDestinationInputData */ .Hx)({
      text: inputText,
      longName: suggestion.longName
    }));
    void trigger([fieldName, idFieldName]);
    (0,_utils_googleTagManagerUtil__WEBPACK_IMPORTED_MODULE_13__/* .event */ .B)(_constants_GoogleTagManagerEventTypes__WEBPACK_IMPORTED_MODULE_14__/* .GoogleTagManagerEventTypes.origin */ .T.origin, {
      destination_id: suggestion.id,
      destination_type: suggestion.destinationType,
      destination: suggestion.longName
    });

    if (displayedPicker) {
      hidePicker();
    }
  };

  var onClearInput = function onClearInput() {
    clearTimeout(inputTimeoutRef.current);
    setValue(idFieldName, null);
    setValue(fieldName, "");
    setValue(typeFieldName, "");
    setValue(longitudeFieldName, null);
    setValue(latitudeFieldName, null);
    appDispatch((0,main_javascripts_features_hotel_hotelSuggestionSlice__WEBPACK_IMPORTED_MODULE_4__/* .setHotelDestinationInputData */ .Hx)({
      text: "",
      longName: ""
    }));
  }; // reactではinputのvalueが外から変更されてもonChangeが呼ばれないため
  // 変更後のvalueをreact-autosuggestが使用できない
  // そのためreact-autosuggestのfocus時のrequestを
  // disableOnFocusRequestで抑止し、独自でリクエストする


  var onFocus = function onFocus() {
    clearTimeout(inputTimeoutRef.current);
    setValue(fieldName, currentInputText);

    if (currentInputText) {
      fetchHotelDestinationSuggestions({
        text: currentInputText
      });
    }
  };

  var onBlur = function onBlur() {
    // onSelectedより先に呼ばれるため遅延させる
    inputTimeoutRef.current = setTimeout(function () {
      if ( // valueRef.current &&
      currentInputLongNameRef.current && valueRef.current !== currentInputLongNameRef.current) {
        setValue(fieldName, currentInputLongNameRef.current);
        void trigger(fieldName);
      }
    }, 400);
  };

  var error = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_17__/* .get */ .U2)(errors, fieldName) || (0,react_hook_form__WEBPACK_IMPORTED_MODULE_17__/* .get */ .U2)(errors, idFieldName);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)("div", {
    css: blockStyle,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_form_InputHidden__WEBPACK_IMPORTED_MODULE_5__/* .InputHidden */ .R, {
      name: idFieldName
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_form_InputHidden__WEBPACK_IMPORTED_MODULE_5__/* .InputHidden */ .R, {
      name: typeFieldName
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_form_InputHidden__WEBPACK_IMPORTED_MODULE_5__/* .InputHidden */ .R, {
      name: "center_coordinates[]"
    }), (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_7__/* .isPhone */ .Mn)(breakpoint) ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .Fragment */ .HY, {
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_suggestionPicker_SuggestionFieldButton__WEBPACK_IMPORTED_MODULE_10__/* .SuggestionFieldButton */ .M, {
        namespace: _constants_FormConstants__WEBPACK_IMPORTED_MODULE_12__/* .FormNamespaces.hotel */ .Z.hotel,
        name: fieldName,
        label: {
          namespace: "hotel",
          label: "都市・地域名、ホテル名から検索",
          colorStyleKey: labelColorStyleKey
        },
        longName: value,
        placeholder: t("form.placeholders.hotel.destinationPlaceholder"),
        onClick: onPickerButtonClick,
        borderColorStyleKey: borderColorStyleKey,
        error: error
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)(_molecules_Modal_FullScreenModalDialog__WEBPACK_IMPORTED_MODULE_9__/* .FullScreenModalDialog */ .H, {
        displayed: displayedPicker,
        closeHandler: hidePicker,
        colorMode: "light",
        disableStopBodyScrolling: disableStopBodyScrolling,
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)("div", {
          css: headerTitleStyle,
          children: t("hotel.destination")
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_suggestionPicker_SuggestionPicker__WEBPACK_IMPORTED_MODULE_8__/* .SuggestionPicker */ .W, {
          name: fieldName,
          suggestions: suggestions,
          placeholder: t("form.placeholders.hotel.destinationPlaceholder"),
          isLoading: isLoading,
          suggestOptions: suggestOptions,
          onRequest: fetchHotelDestinationSuggestions,
          onSelected: onSelected,
          onFocus: onFocus,
          onBlur: onBlur,
          onClear: onClearInput
        })]
      })]
    }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(main_javascripts_components_form_InputAutosuggestBlock__WEBPACK_IMPORTED_MODULE_1__/* .InputAutosuggestBlock */ .A, {
      namespace: "hotel",
      label: {
        namespace: "hotel",
        label: "都市・地域名、ホテル名から検索",
        colorStyleKey: labelColorStyleKey
      },
      input: {
        name: fieldName,
        value: value,
        type: "text",
        placeholder: "目的地またはホテル名を入力"
      },
      error: error,
      onSelected: onSelected,
      onFocus: onFocus,
      onBlur: onBlur,
      fetchDestinationSuggest: fetchHotelDestinationSuggestions,
      suggestOptions: suggestOptions,
      suggestions: suggestions,
      onClear: onClearInput,
      disableOnFocusRequest: true,
      alwaysShowSuggestions: true,
      borderColorStyleKey: borderColorStyleKey
    })]
  });
};
var blockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_19__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_2__/* .space.atom */ .D.atom, " 0 0;flex:1;" + ( true ? "" : 0),  true ? "" : 0);
var headerTitleStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_19__.css)("position:absolute;top:0;left:50%;line-height:3rem;font-size:", _styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_11__/* .fontSize.mediumHeading */ .JB.mediumHeading, ";font-weight:bold;letter-spacing:", _styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_11__/* .letterSpacing.text */ .rX.text, ";transform:translateX(-50%);" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 27114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ CheckinInput; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87536);
/* harmony import */ var main_javascripts_components_form_CalendarDateBlock__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33935);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var CheckinInput = function CheckinInput(props) {
  var namespace = props.namespace,
      isActive = props.isActive,
      onClick = props.onClick,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      inputBlockRef = props.inputBlockRef;
  var fieldName = "checkin_date";

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useFormContext */ .Gc)(),
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors;

  var value = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useWatch */ .qo)({
    control: control,
    name: fieldName
  });
  var attrs = {
    name: fieldName,
    namespace: namespace,
    label: {
      label: "チェックイン",
      colorStyleKey: labelColorStyleKey
    },
    date: value,
    onClick: onClick,
    isActive: isActive,
    error: (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2)(errors, fieldName),
    inputBlockRef: inputBlockRef,
    borderColorStyleKey: borderColorStyleKey
  };
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(main_javascripts_components_form_CalendarDateBlock__WEBPACK_IMPORTED_MODULE_2__/* .CalendarDateBlock */ .A, _objectSpread({}, attrs));
};

/***/ }),

/***/ 82011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ CheckoutInput; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87536);
/* harmony import */ var main_javascripts_components_form_CalendarDateBlock__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33935);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var CheckoutInput = function CheckoutInput(props) {
  var namespace = props.namespace,
      isActive = props.isActive,
      onClick = props.onClick,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      inputBlockRef = props.inputBlockRef;
  var fieldName = "checkout_date";

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useFormContext */ .Gc)(),
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors;

  var value = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useWatch */ .qo)({
    control: control,
    name: fieldName
  });
  var attrs = {
    name: fieldName,
    namespace: namespace,
    label: {
      label: "チェックアウト",
      colorStyleKey: labelColorStyleKey
    },
    date: value,
    onClick: onClick,
    isActive: isActive,
    error: (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2)(errors, fieldName),
    inputBlockRef: inputBlockRef,
    borderColorStyleKey: borderColorStyleKey
  };
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(main_javascripts_components_form_CalendarDateBlock__WEBPACK_IMPORTED_MODULE_2__/* .CalendarDateBlock */ .A, _objectSpread({}, attrs));
};

/***/ }),

/***/ 30522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ useUserAccount; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95094);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _sentry_node__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39666);
/* harmony import */ var main_javascripts_slices_accountParamSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12297);
/* harmony import */ var main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25968);
/* harmony import */ var main_javascripts_slices_currentUserSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94265);






 // useAccountのredux toolkit版
// liff.initをここですると、同一ページでLiffTypesが違うところから来ると不整合が出るのでしない。必要なところでinitする

var useUserAccount = function useUserAccount(store) {
  var enableSocialSignedInCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();

  var loadAccount = function loadAccount() {
    return store.dispatch((0,main_javascripts_slices_accountParamSlice__WEBPACK_IMPORTED_MODULE_2__/* .fetchAccountParams */ .Nv)({
      param: ""
    })).then(_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .unwrapResult */ .SI).then(function (result) {
      var accountParams = result;

      if (accountParams) {
        // 取得したデータを各reducerで直接保存しているため
        // 以前のinitCurrentUser/initAccountParamsは不要
        if (enableSocialSignedInCheck) {
          checkInitializedSocial(accountParams.facebookAppId);
        }
      }
    });
  };

  var checkLIFFState = function checkLIFFState() {
    try {
      var _liff;

      var context = (_liff = liff) === null || _liff === void 0 ? void 0 : _liff.getOS();

      if (context) {
        store.dispatch((0,main_javascripts_slices_currentUserSlice__WEBPACK_IMPORTED_MODULE_4__/* .setIsLIFFInitialized */ .hV)(true));
      }

      if (liff.id && liff.isLoggedIn()) {
        store.dispatch((0,main_javascripts_slices_currentUserSlice__WEBPACK_IMPORTED_MODULE_4__/* .setIsLIFFLoggedIn */ .ux)(true));
      }
    } catch (_unused) {// do nothing
    }
  };

  var onLoadScriptLIFF = function onLoadScriptLIFF() {
    checkLIFFState();
  };

  var loadScript = function loadScript(url, onload) {
    var script = document.createElement("script");
    script.src = url;
    script.async = true;
    script.onload = onload ? onload : null;
    document.body.appendChild(script);
  };

  var checkInitializedSocial = function checkInitializedSocial(facebookAppId) {
    if (typeof liff !== "undefined") {
      checkLIFFState();
    } else {
      loadScript(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_3__/* .LINE_LIFF_SDK_URL */ .i3, onLoadScriptLIFF);
    } // FacebookMessengerは現在使用していない


    if (facebookAppId) {//   (window as any).MessengerExtensions?.getContext(
      //     facebookAppId,
      //     (): void => {
      //       store.dispatch(setIsFacebookMessengerInitialized(true));
      //     },
      //     (err: any): void => {
      //       console.log("FBM ERROR ", err);
      //     }
      //   );
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (router.isReady) {
      loadAccount()["catch"](function (e) {
        console.error(e);

        if (true) {
          _sentry_node__WEBPACK_IMPORTED_MODULE_6__/* .captureException */ .Tb(e.errorMessages || e);
        }
      });
    }
  }, [router.isReady]);
  return;
};

/***/ })

}]);